import { columnTypes } from '@/services/Grid/ColumnTypes';
import DownloadHandIn from '@/components/Grid/Renderers/DownloadHandIn';
import DownloadReport from '@/components/Grid/Renderers/DownloadReport';

export const handInGridColumnTypes = columnTypes;

export const handInDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const handInGridColumns = [
  {
    headerName: 'ID',
    field: 'reportId',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Download',
    field: '',
    width: 150,
    minWidth: 150,
    cellRendererFramework: DownloadHandIn,
  },
  {
    headerName: 'Job ID',
    field: 'jobId',
    width: 100,
    minWidth: 100,
  },
  {
    headerName: 'Job Title',
    field: 'job.job',
    minWidth: 300,
  },
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 300,
  },
  {
    headerName: 'Handover Date',
    field: 'handoverDate',
    type: 'dateColumn',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'No. Actions',
    field: 'numRecommendations',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'No. Properties',
    field: 'numProperties',
    width: 170,
    minWidth: 170,
  },

  {
    headerName: 'No. Rollbacks',
    field: 'numPropertiesRolledBack',
    width: 250,
    minWidth: 250,
  },
  {
    headerName: 'No. Re-Published',
    field: 'numRepublishedAssessments',
    width: 150,
    minWidth: 150,
  },
  {
    headerName: 'No. Cat B',
    field: 'numPropertiesCatB',
    width: 150,
    minWidth: 150,
  },
];
